import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

/**
 * 2026-10-21 · 「テストデータの整理（データ管理・準備用）」は本番運用開始につき削除。
 *
 * ブックマークやリンクから来た人のために、設定へ戻して一言だけ知らせる。
 * ソルダリング試作データの「元に戻す」だけは 30日 残してある（API のみ）。
 */
export default function DataPrepRemoved() {
  const navigate = useNavigate();
  useEffect(() => {
    toast.message('この機能は本番運用開始のため削除されました');
    navigate('/settings', { replace: true });
  }, [navigate]);
  return <div data-testid="data-prep-removed" />;
}
